import { Text } from "@mantine/core";
import { useModals } from "@mantine/modals";
import { showNotification } from "@mantine/notifications";
import { Check } from "tabler-icons-react";
import useMutateTimeSlotData from "./useMutateTimeSlotData";
import { deleteTimeSlot } from "../../api/timeSlots";

export default function useDeleteTimeSlot() {
  const modals = useModals();

  const onSuccess = () => {
    showNotification({
      title: "Time slot deleted",
      icon: <Check />,
      message: `The time slot has been deleted!`,
    });
  };

  const onError = (error: string) => {
    showNotification({
      title: `Something went wrong`,
      message: `An error occurred while deleting the timeSlot(s). ${error}`,
      color: "red",
    });
  };

  const { mutate } = useMutateTimeSlotData(deleteTimeSlot, onSuccess, onError);

  const openModal = (ids: string[], onConfirm?: () => void) =>
    modals.openConfirmModal({
      centered: true,
      title: "Are you sure?",
      children: (
        <Text
          size="sm"
          sx={(theme) => ({
            color:
              theme.colorScheme === "dark"
                ? theme.colors.dark[0]
                : theme.colors["custom-gray"][0],
          })}
        >
          This action cannot be undone. Are you sure you want to delete{" "}
          {ids.length > 1 ? `these ${ids.length} time slots` : "this time slot"}
          ?
        </Text>
      ),
      labels: { confirm: "Delete", cancel: "Cancel" },
      confirmProps: { color: "custom-red" },
      onCancel: () => {},
      onConfirm: async () => {
        await mutate(ids);
        onConfirm?.();
      },
    });

  return {
    openModal,
  };
}
